/**
 * FpsMonitor — rolling FPS average over a fixed window.
 *
 * Used by the QualityScaler and (optionally) by a debug overlay. Cheap: just
 * an array of recent dt values.
 */
export class FpsMonitor {
  constructor(windowSize = 60) {
    this.windowSize = windowSize;
    this._samples = [];
  }

  /** Call from your scene update with the frame delta in ms. */
  sample(deltaMs) {
    if (deltaMs <= 0) return;
    this._samples.push(deltaMs);
    if (this._samples.length > this.windowSize) this._samples.shift();
  }

  getFps() {
    if (this._samples.length === 0) return 60;
    let sum = 0;
    for (const s of this._samples) sum += s;
    const avgMs = sum / this._samples.length;
    return 1000 / avgMs;
  }
}
